/**
 * Route for `google-ads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoogleAdsIntegrationPage } from "../features/google-ads-integration/GoogleAdsIntegrationPage";

export const googleAdsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/google-ads-integration",
	component: GoogleAdsIntegrationPage,
});

export default googleAdsIntegrationRoute;
